import React, {AnchorHTMLAttributes, ImgHTMLAttributes, MouseEvent, VideoHTMLAttributes} from "react";
import {useAuthorizedFileUrl} from "../../helpers/hooks/useAuthorizedFileUrl";
import {openAuthorizedFile} from "../../helpers/request/connect";

export const AuthorizedImage = ({src, ...props}: ImgHTMLAttributes<HTMLImageElement>) => {
    const authorizedSrc = useAuthorizedFileUrl(src);
    if (!authorizedSrc) return null;
    return <img alt="" {...props} src={authorizedSrc}/>;
}

export const AuthorizedVideo = ({src, ...props}: VideoHTMLAttributes<HTMLVideoElement>) => {
    const authorizedSrc = useAuthorizedFileUrl(src);
    return <video {...props} src={authorizedSrc || undefined}/>;
}

export const AuthorizedFileLink = ({href, fileName, onClick, children, ...props}: AnchorHTMLAttributes<HTMLAnchorElement> & { fileName?: string }) => {
    const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
        onClick?.(event);
        if (event.defaultPrevented || !href) return;

        event.preventDefault();
        openAuthorizedFile(href, fileName).catch(() => undefined);
    };

    return <a {...props} href={href} onClick={handleClick}>{children}</a>;
}
